import React from 'react'
import { defaultTo, map, pluck, propOr, sum } from 'ramda'
import TableRow from '@mui/material/TableRow'
import TableCell from '@mui/material/TableCell'
import TableBody from '@mui/material/TableBody'
import Table from '@mui/material/Table'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import CurrencyMoney from '~/components/Money/CurrencyMoney'

function InvoiceSummary ({ lineItems, currency }) {
  const { t } = useTranslation()
  const lineItemsQuantity = lineItems.length

  const unitsOrdered = pluck('quantity', lineItems)
  const unitsOrderedInt = map(defaultTo(0), unitsOrdered)
  const unitsOrderedTotal = sum(unitsOrderedInt)

  const subTotal = map(
    item => {
      const quantity = defaultTo(0, item.quantity)
      const price = propOr(0, 'price', item)
      return quantity * price
    },
    lineItems
  )
  const subTotalSum = sum(subTotal)

  return (
    <Table size="small">
      <TableBody>
        <TableRow>
          <TableCell>{t('Line items')}</TableCell>
          <TableCell />
          <TableCell align="right">
            {lineItemsQuantity}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('Units ordered')}</TableCell>
          <TableCell />
          <TableCell align="right">
            {unitsOrderedTotal}
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('Subtotal')}</TableCell>
          <TableCell />
          <TableCell align="right">
            <CurrencyMoney currency={currency} value={subTotalSum} />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>{t('Shipping charges')}</TableCell>
          <TableCell />
          <TableCell align="right">
            <CurrencyMoney currency={currency} value={0} />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <strong>{t('Total')}</strong>
          </TableCell>
          <TableCell />
          <TableCell align="right">
            <CurrencyMoney currency={currency} value={subTotalSum} />
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  )
}

InvoiceSummary.defaultProps = {
  lineItems: []
}

InvoiceSummary.propTypes = {
  lineItems: PropTypes.array.isRequired,
  currency: PropTypes.string
}

export default InvoiceSummary
